import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { fetchSingleUser } from '@actions/users/fetchSingleUser';
import { getFullUser, getUserPostSuccess } from '@selectors/users';

import UpdateUserPasswordModal from './UpdateUserPasswordModal';
import DeleteUserModal from './DeleteUserModal';
import UpdateUserModal from './UpdateUserModal';

import { RootState } from '@reducers/index';
import User from './User';
import usePrevious from 'lib/src/hooks/usePrevious';

const UserContainer: React.FC = () => {
    const { id, action } = useParams<ParamTypes>();
    const dispatch = useDispatch();

    // const error = useSelector(getUsersError);
    const user = useSelector((state: RootState) => getFullUser(state, +id));
    const postSuccess = useSelector(getUserPostSuccess);
    const prevSuccess = usePrevious(postSuccess);

    useEffect(() => {
        dispatch(fetchSingleUser(+id));
    }, [id, dispatch]);

    useEffect(() => {
        if (postSuccess && !prevSuccess) dispatch(fetchSingleUser(+id));
    }, [postSuccess, prevSuccess, id, dispatch]);

    return (
        <>
            <User user={user} />
            {action === 'delete' && <DeleteUserModal user={user} />}
            {!!user && action === 'edit-password' && <UpdateUserPasswordModal user={user} />}
            {!!user && action === 'edit' && <UpdateUserModal user={user} />}
        </>
    );
};

interface ParamTypes {
    id: string;
    action: string;
}

export default UserContainer;
